export const onClientEntry = () => {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('ag-mode') : null;
  const mode = stored || 'dark';
  document.documentElement.setAttribute('data-mode', mode);

  // Drop stale offline-plugin service workers after deploys (they can block hydration).
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
};
